import { Tabs } from "@reach/tabs";
import { Tab } from "../../../components/ReachTabs/Tab";
import { TabList } from "../../../components/ReachTabs/TabList";
import { PageHeader, PageTitle } from "../../portalPageLayout";

/**
 * This component create tabs that function as navbars.
 * This component can be used to compose such navbars across our application.
 * @param param0
 * @returns
 */
export const NavBarTabs = ({
  handleTabsChange,
  pageTitle,
  tabs,
  tabIndex,
}: {
  handleTabsChange: (index: number) => void;
  pageTitle: string;
  tabs: string[];
  tabIndex: number;
}) => {
  return (
    <div className="nav-bar-tabs-container">
      <PageHeader className="nav-bar-tabs-header">
        <PageTitle>{pageTitle}</PageTitle>
      </PageHeader>
      <div className="nav-bar-tabs">
        <Tabs index={tabIndex} onChange={handleTabsChange}>
          <TabList width={"100%"}>
            {tabs.map((tab) => (
              <Tab key={tab}>{tab}</Tab>
            ))}
          </TabList>
        </Tabs>
      </div>
    </div>
  );
};
